import Icon from '@/asset/Icon'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_LOW,
  REDO_COMMAND,
  UNDO_COMMAND,
} from 'lexical'
import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'

export default function UndoRedoUIPlugin() {
  const [editor] = useLexicalComposerContext()
  const [canUndo, setCanUndo] = useState<boolean>(false)
  const [canRedo, setCanRedo] = useState<boolean>(false)
  useEffect(() => {
    mergeRegister(
      editor.registerCommand(
        CAN_REDO_COMMAND,
        (canRedo) => {
          setCanRedo(canRedo)
          return false
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        CAN_UNDO_COMMAND,
        (canUndo) => {
          setCanUndo(canUndo)
          return false
        },
        COMMAND_PRIORITY_LOW
      )
    )
  })
  return (
    <ButtonGroup className="me-2" aria-label="undo-redo-ui">
      <Button
        disabled={!canUndo}
        onClick={() => editor.dispatchCommand(UNDO_COMMAND, undefined)}
        variant="outline-secondary"
      >
        <Icon type="undo" />
      </Button>
      <Button
        disabled={!canRedo}
        onClick={() => editor.dispatchCommand(REDO_COMMAND, undefined)}
        variant="outline-secondary"
      >
        <Icon type="redo" />
      </Button>
    </ButtonGroup>
  )
}
